import React from 'react';
import styled from 'styled-components';

import {useCurrentPage} from '@/hooks/useCurrentPage';
import ContentContainer from '@/components/ContentContainer';

function DveriDefaultTemplate() {
  const page = useCurrentPage();
  if (!page) return null;

  return (
    <ContentContainer>
      <Component>
        <Title>{page.title}</Title>
        <Content
          dangerouslySetInnerHTML={{ __html: page.body || '' }}
        ></Content>
      </Component>
    </ContentContainer>
  );
}

const Component = styled.div`
  margin: 40px 0 70px;
`;

const Title = styled.h1`
  font-size: 40px;
`;

const Content = styled.div`
  font-size: 24px;
  line-height: 36px;
  max-width: 1200px;

  .image-style-side {
    float: right;
    margin: 20px 0 20px 20px;
  }

  p {
    margin-bottom: 20px;
  }

  h2,
  h3 {
    margin: 40px 0 20px;
    font-size: 32px;
  }

  strong {
    font-weight: bold;
  }
`;

export default DveriDefaultTemplate;
